import { createActionGroup, props } from '@ngrx/store';

import { IntervalCode } from '@ninety/platform/models/issues/interval-code';
import type { IssuesSolveRate } from '@ninety/platform/models/issues/issues-solve-rate';

/**
 * Cross-module meeting issues events/actions
 *
 * These actions are shared between meeting and issues-v2 modules to avoid circular dependencies.
 * Actions that need to be dispatched from issues-v2 but handled by meeting effects should be placed here.
 */
export const MeetingIssuesEvents = createActionGroup({
  source: 'Meeting Issues Events',
  events: {
    'Toggle Voting Enabled': props<{ votingEnabled: boolean }>(),
    'Set Completed State': props<{ issueId: string; completed: boolean }>(),
    Created: props<{ intervalCode: IntervalCode; teamId: string }>(),
    Deleted: props<{ issueId: string; isShortTerm: boolean }>(),
    'Team Changed': props<{ issueId: string; teamId: string; isShortTerm: boolean }>(),
    'Interval Changed': props<{ issueId: string; intervalCode: IntervalCode }>(),
    Archived: props<{ issueId: string; isShortTerm: boolean; completed: boolean }>(),
    /**
     * Issues settings panel saved. An untouched control arrives as `undefined` rather than being
     * omitted, so handlers must test `!== undefined` instead of checking for the key.
     */
    'Settings Saved': props<{
      teamId: string;
      issueVoting?: boolean;
      issuesSolveRate?: IssuesSolveRate;
      votesPerUser?: number;
    }>(),
  },
});
